<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
import 'element-ui/lib/theme-chalk/index.css';
import './assets/css/public.css';
import './assets/css/elecustom.css';
import './assets/css/page.css';

export default {
  name: 'App',

  mounted() {}
};
</script>
<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  height: 100vh;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
